import isEqual from "lodash/isEqual";
export const stringChangeComparator = (prev: any, current: any) => isEqual(prev, current);
